module.exports = "https://static.wmbcdn.com/uniweb/images/f60a8ff75b42fd8e0ba5d15a66715e78.svg";